import React, {useEffect, useRef, useState, useMemo} from 'react';
import InitStep from './Steps/InitStep';
import ShowLocation from './Steps/ShowLocation';
import CompleteStep from './Steps/CompleteStep';
import {isMobileOnly} from 'react-device-detect';
import PreLoader from './Steps/PreLoader';
import ErrorClientLocationPopUp from './Steps/ErrorClientLocationPopUp';
import ErrorClientLocation from './Steps/ErrorClientLocation';
import ClientLocationLead from './Steps/ClientLocationLead';
import {PageView, ErrorView} from './Shared/Constants';

const ClientLocation = ({data, context}) => {
  const [step, setStep] = useState('');
  const [currentError, setCurrentError] = useState();
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [coords, setCoords] = useState(null);
  const [geoError, setGeoError] = useState(null);
  const guid = GetGuidIdFromUrl();

  function validation() {
    if (!isMobileOnly) {
      setCurrentError(ErrorView.Desktop);
      setStep(PageView.MobileError);
    } else if (!guid) {
      setCurrentError(ErrorView.GUID);
      setIsPopUpOpen(true);
      setStep(PageView.ErrorPopUp);
    } else if (step === undefined || step === '') {
      setStep(PageView.Init);
    }
  }

  useEffect(() => {
    validation();
    window.scrollTo(0, 0);
  }, [step]);

  useEffect(() => {
    if (!isPopUpOpen && step != PageView.Init) {
      setStep(PageView.Init);
    }
  }, [isPopUpOpen]);

  const changeStep = (step) => {
    if (step == PageView.ErrorPopUp) {
      setIsPopUpOpen(true);
    }
    setStep(step);
  };

  function closeErrorPopUp() {
    setIsPopUpOpen(false);
  }
  function switchStep() {
    switch (step) {
      case PageView.Init:
        return (
          <InitStep
            data={data}
            context={context}
            changeStep={changeStep}
            setCurrentError={setCurrentError}
            guid={guid}
            setCoords={setCoords}
            setGeoError={setGeoError}
          />
        );
      case PageView.Loader:
        return <PreLoader data={data} context={context} isFromLeadPage={false} />;
      case PageView.LeadLoader:
        return <PreLoader data={data} context={context} isFromLeadPage />;
      case PageView.ShowLocation:
        return (
          <ShowLocation
            data={data}
            context={context}
            guid={guid}
            changeStep={changeStep}
            setCurrentError={setCurrentError}
            coords={coords}
            geoError={geoError}
            setCoords={setCoords}
            setGeoError={setGeoError}
          />
        );
      case PageView.ErrorPopUp:
        return (
          <ErrorClientLocationPopUp
            isErrorPopUpOpen={isPopUpOpen}
            closePopUp={closeErrorPopUp}
            data={data}
            errorId={currentError}
            changeStep={changeStep}
          />
        );
      case PageView.MobileError:
        return <ErrorClientLocation data={data} errorId={currentError} changeStep={changeStep} />;
      case PageView.Lead:
        return <ClientLocationLead data={data} context={context} changeStep={changeStep} setCurrentError={setCurrentError} />;
      case PageView.Completed:
        return <CompleteStep data={data} context={context} isFromLeadPage={false} />;
      case PageView.LeadCompleted:
        return <CompleteStep data={data} context={context} isFromLeadPage />;
      default:
        return (
          <ErrorClientLocationPopUp
            isErrorPopUpOpen={isPopUpOpen}
            closePopUp={closeErrorPopUp}
            data={data}
            errorId={ErrorView.General}
            changeStep={changeStep}
          />
        );
    }
  }

  return <div>{switchStep()}</div>;
};

function GetGuidIdFromUrl() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('guid');
}

export default ClientLocation;
